module.exports = __webpack_public_path__ + "img/floor_type22.0b6d3045.png";